<template>
  <div class="selectCb">
    <div class="save" @click="save">选择</div>
    <div class="wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="itemWrap" v-for="(item, index) in data" :key="index">
          <div class="left">
            <van-checkbox
              v-model="item.checked"
              shape="square"
              checked-color="rgb(58, 117, 197)"
            ></van-checkbox>
          </div>
          <div :class="{ item: true, active: item.checked }">
            <div>
              <div class="title">{{ item.applyNum  }}</div>
              <div class="text">{{ item.createTime }}</div>
            </div>
            <div>
              <div class="title">{{ item.travelType }}</div>
              <!-- <div class="nobx" v-show="item.status">未报销</div> -->
              <!-- <div class="text" v-show="!item.status">已报销</div> -->
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      finished: false,
      total:0,
      data: [],
      searchForm:{
        pageNum:1,
        pageRows:10,
      },
      checked: false,
    };
  },
  destroyed() {
    this.$bus.$off("selectCb", () => {});
  },
  methods: {
    onLoad(){
      this.searchForm.pageRows += this.searchForm.pageRows
      this.getData(this.searchForm)
    },
    save() {
      let arr = this.data.filter((item) => item.checked);
      if (!arr.length) {
        this.$toast({
          type: "fail",
          message: "请选择单据",
        });
        return;
      }
      if (arr.length > 1) {
        this.$toast({
          type: "fail",
          message: "一次只能选择一张单据",
        });
        return;
      }
      this.$bus.$emit("selectCb", arr[0]);
      this.$router.go(-1);
    },
    getData() {
      this.$api
        .post("/payment/center/reimburse/queryExcessApply", {
          reqData: {
            workflow: "1",
            ...this.searchForm
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.data = res.repData.list.map((item) => {
              return {
                ...item,
                checked: false,
              };
            });
            this.total = res.repData.total;
            this.loading = false
            if(this.total == this.data.length){
              this.finished = true
            }
          }else{
            this.finished = true
          }
        }).catch(()=>{
          this.finished = true
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.selectCb {
  height: 100%;
  display: flex;
  flex-direction: column;
  .save {
    font-size: 14px;
    position: absolute;
    top: 12px;
    right: 20px;
    color: #1989fa;
    z-index: 100;
  }
  .wrap {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;
  }
  .itemWrap {
    display: flex;
    align-items: center;
  }
  .item {
    flex: 1;
    margin-left: 20px;
    border-radius: 4px;
    box-shadow: 1px 2px 2px 0 #e2dada;
    background: #fff;
    padding: 16px 24px;
    margin-bottom: 10px;
    color: rgb(153, 153, 153);
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    .title {
      color: rgb(44, 44, 44);
      margin-top: 4px;
      margin-bottom: 4px;
      // font-weight: bold;
      // font-family:"Microsoft YaHei",微软雅黑,"Microsoft JhengHei",华文细黑,STHeiti,MingLiu;
    }
    .nobx {
      color: rgb(60, 119, 198);
    }
  }
  .item.active {
    border: 1px solid rgb(60, 119, 198);
    box-shadow: 0 0 0 0;
  }
  .btnBox {
    padding: 10px 20px;
    background: #fff;
    button {
      width: 100%;
      border-radius: 5px;
      background: rgb(58, 117, 197);
      font-size: 12px;
      color: #fff;
      .sc {
        font-size: 12px;
        margin-right: 6px;
        color: #fff;
      }
    }
  }
}
</style>